export function renderBlob(blob, renderer){
    let verts = []
    let center = blob.bodies[0].position
    for(let i = 0; i < blob.cell.vertices.length;i++){
        let p = {...blob.bodies[i].position}
        if(i> blob.cell.vertices.length-blob.cell.resolution-1){
            let normal = Math.atan2(p.y-center.y,p.x-center.x)
            p.x += Math.cos(normal) * blob.bodies[i].circleRadius
            p.y += Math.sin(normal) * blob.bodies[i].circleRadius
        }
        verts.push(p)
    }
    renderer.beginShape(renderer.TRIANGLES)
    blob.cell.indices.forEach(i=>{
        renderer.fill(blob.cell.colors[i])
        renderer.vertex(verts[i].x,verts[i].y)
    })
    renderer.endShape(renderer.CLOSE)
}

export function renderBlobScaled(blob, renderer, scale){
    let verts = []
    let center = blob.bodies[0].position
    for(let i = 0; i < blob.cell.vertices.length;i++){
        let p = {...blob.bodies[i].position}
        if(i> blob.cell.vertices.length-blob.cell.resolution-1){
            let normal = Math.atan2(p.y-center.y,p.x-center.x)
            p.x += Math.cos(normal) * blob.bodies[i].circleRadius
            p.y += Math.sin(normal) * blob.bodies[i].circleRadius
        }
        verts.push(p)
    }
    renderer.beginShape(renderer.TRIANGLES)
    blob.cell.indices.forEach(i=>{
        renderer.fill(blob.cell.colors[i])
        renderer.vertex(verts[i].x*scale,verts[i].y*scale)
    })
    renderer.endShape(renderer.CLOSE)
}


export function renderLine(segment,renderer){
    renderer.line(segment.a.x,segment.a.y,segment.b.x,segment.b.y)
}